import React, { useState } from "react";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import MobileBatuk from "../assets/images/new/Mobile_batuk-removebg-preview.png";
import ComingSoonModal from "./ComingSoonModal";
import mockup from "../assets/images/new/AppImg.png"
import { t } from "i18next";
const MobileAppAd = () => {
  const [showComingSoon, setShowComingSoon] = useState(false)
  return (
    <div
      className="card text-center shadow-sm p-3 border-0"
      style={{
        background: "#fff",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={mockup}
        alt="Mobile App"
        className=" rounded"
        style={{ maxHeight: "60%", objectFit: "cover", maxWidth: "60%" }}
      />
      <div className="card-body">
        <h5 className="card-title fw-bold">{t("Download Our Mobile App")}</h5>
        <p className="card-text ">
          {/* {t("Connect with divine energy, daily rituals, & puja bookings — bring spirituality closer to your life")} <br />
          {t("Download our Spiritual App today!")} */}

          {t("Connect with divine energy, daily rituals, & puja bookings — bring spirituality closer to your life. Download our Spiritual App today!")} </p>
        <div className="d-flex justify-content-center gap-2">
          <a
            href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-dark d-flex align-items-center gap-2"
            style={{ backgroundColor: '#a52444', border: 'none' }}
          >
            <FaGooglePlay /> Play Store
          </a>
          <a
            href="https://apps.apple.com/in/app/myomnamo/id6747122767"
            // onClick={() => setShowComingSoon(true)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-dark d-flex align-items-center gap-2"
            style={{ backgroundColor: '#a52444', border: 'none' }}
          >
            <FaApple /> App Store
          </a>
        </div>
      </div>
      <ComingSoonModal show={showComingSoon} onClose={() => setShowComingSoon(false)} />
    </div>
  );
};

export default MobileAppAd;
